const E = {
  'Recent Activity': 'Recent Activity',
  'There are currently no': 'There are currently no',
  available: 'available. ',
  'If you’d like to create a new': 'If you’d like to create a new',
  'please click': ' please click',
  New: 'New',
  'Please contact your Bureau Veritas representative for access to the invoice module': 'Please contact your Bureau Veritas representative for access to the invoice module',
  noInvoices: 'There are currently no invoices available.',
  'If you need assistance, please contact your Bureau Veritas representative&#46;': 'If you need assistance, please contact your Bureau Veritas representative.',
  'For access to invoices, please contact your Bureau Veritas representative&#46;': 'For access to invoices, please contact your Bureau Veritas representative.',
};

const F = {
  'Recent Activity': 'Activité récente',
  'There are currently no': 'Il n\'y a actuellement aucun',
  available: 'disponible. ',
  'If you’d like to create a new': 'Pour en créer une nouvelle, cliquez sur',
  'please click': ' Cliquez s\'il vous plait',
  New: 'Nouveau',
  'Please contact your Bureau Veritas representative for access to the invoice module': 'Veuillez contacter votre représentant des Lab BV pour accéder au module de facturation.',
  noInvoices: 'Aucune facture disponible pour le moment.',
  'If you need assistance, please contact your Bureau Veritas representative&#46;': 'Si vous avez besoin d’aide, veuillez contacter votre représentant des Lab BV.',
  'For access to invoices, please contact your Bureau Veritas representative&#46;': 'Veuillez contacter votre représentant des Lab BV pour accéder aux factures.',
};

export default { E, F };



// WEBPACK FOOTER //
// ./src/constants/translations/overview.js